import { HandFist } from "lucide-solid";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

function GitHubMark() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" class="size-4" fill="currentColor">
      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" />
    </svg>
  );
}

export function LoginPage() {
  const next = encodeURIComponent(location.pathname + location.search);
  return (
    <div class="flex min-h-screen items-center justify-center p-4">
      <Card class="w-full max-w-sm">
        <CardHeader class="items-center text-center">
          <div class="bg-primary text-primary-foreground mx-auto mb-2 flex size-11 items-center justify-center rounded-xl">
            <HandFist class="size-6" />
          </div>
          <CardTitle class="text-xl">FistOS</CardTitle>
          <CardDescription>Control server for your FistOS phones.</CardDescription>
        </CardHeader>
        <CardContent class="grid gap-3">
          <Button as="a" href={`/auth/login?next=${next}`} rel="external" size="lg" class="w-full">
            <GitHubMark /> Sign in with GitHub
          </Button>
          <p class="text-muted-foreground text-center text-xs">
            Only the GitHub account configured on this server can sign in.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
